import * as earnts from 'earn-ts';
import { types as rs } from 'earn-ts';
import { gentoken } from '.';

export let store: any;

export const injectStore = (_store: any) => {
  store = _store;
};

export function newOrderMenuSet(): rs.OrderMenuSet {
  return {
    ...earnts.emptyOrderMenuSet,
    id: gentoken(),
  };
}

export class StoredMenuDef implements earnts.IMenuDefProvider {
  get<T>(cls: string, id: string): T {
    try {
      switch (cls) {
        case earnts.MenuTypes.FoodItem: {
          return store.getState().order?.foods[id] as T;
        }
        case earnts.MenuTypes.FoodOptionGroup: {
          return store.getState().order?.optionGroup[id] as T;
        }
        case earnts.MenuTypes.MenuList: {
          return store.getState().order?.lists[id] as T;
        }
        case earnts.MenuTypes.MenuSet: {
          return store.getState().order?.menus[id] as T;
        }
        default: {
          throw new Error(`Unknown menu type or id`);
        }
      }
    } catch (error) {
      throw new Error(`Something went wrong, ${error}`);
    }
  }

  config(): earnts.MenuDefConfig {
    return store.getState().order?.menudef;
  }

  setVersion(v: number | null): void {
    if (store && store.dispatch) {
    }
  }
}

// Create a singleton instance of StoredMenuDef
export const storedMenuDef = new StoredMenuDef();

export function priceOrder(o: rs.Order) {
  return earnts.priceOrder(storedMenuDef, o);
}

export function priceMenuSet(ms: rs.OrderMenuSet) {
  return earnts.priceMenuSet(storedMenuDef, ms);
}

export function priceItem(item: rs.OrderItem, menu_sec: rs.MenuSection, additive_set: boolean) {
  return earnts.priceItem(storedMenuDef, item, menu_sec, additive_set);
}